module.exports = __webpack_public_path__ + "img/footer_wave.aa4e53a9.svg";